module.exports = __webpack_public_path__ + "img/Pin at home Icon - charcoal.7e76436a.svg";